import { InputText } from "primereact/inputtext";
import "../Css/supportPanel.css";
import { useRef, useState } from "react";
import SupportFlow from "./SupportFlow";
import { Toast } from "primereact/toast";

function SupportPanel({onClosePannel}) {
  const stickers = [
    "😄", "😍", "😂", "😭", "😎", "👍", "🎉", "🐴", "🏇", "🌟",
    "🤠", "🙈", "🦄", "🐶", "🐱", "🍀", "💖", "😡", "🤯", "🥹",
    "😴", "🤩", "🥳", "😇", "🤗", "💩", "🐎", "🐾", "🍎", "⚡",
  ];

  const [message, setMessage] = useState("");
  const [extraInfo,setExtraInfo] = useState();
  const [showStickers, setShowStickers] = useState(false);
  const inputRef = useRef(null);
  const toast = useRef(null);

  const handleStickerClick = (sticker) => {
    const cursorPos = inputRef.current.selectionStart;
    const newText =
      message.slice(0, cursorPos) + sticker + message.slice(cursorPos);
    setMessage(newText);
    inputRef.current.focus();
    setShowStickers(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      setExtraInfo(message);
    }
  };

  const sendClicked = () =>
  {
    if(message)
      setExtraInfo(message);
    else
     toast.current.show({severity: 'error', summary: 'لطفا یک محصول را انتخاب کنید یا \"بذار خودم توضیح بدم\" رو بزنید'});

  }



  return (
    <div id="support-panel">
      
      <Toast ref={toast} position="center"></Toast>

      {/* هدر پشتیبانی */}
      <span id="support-row1">
        <img
          className="support-avatar"
          src={`${process.env.REACT_APP_BACK}/avatars/ac043faf42692a0495f731250e24d5d3.png`}
          alt="پشتیبانی فلیکا"
        />
        <div>
          <h6>پشتیبانی فلیکا</h6>
          <p>بهترین محصول را به شما پیشنهاد می‌دهیم</p>
        </div>
      </span>

      {/* بدنه گفتگو */}
      <div
        id="support-row2"
        style={{
          background: `#f3f3f3 url(${require("../images/bgchat.png")})`,
        }}
      >
        <SupportFlow
          extraInfo={extraInfo}
          onSendExtraInfo={() => setMessage("")}
          onClosePannel={onClosePannel}
        />
      </div>

      {/* بخش تایپ و ایموجی */}
      <span id="support-row3">
        <InputText
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="پیامی بنویسید ..."
          ref={inputRef}
          onKeyDown={handleKeyPress}
          className="support-input"
        />
        <button
          onClick={() => setShowStickers((prev) => !prev)}
          className="stickerbutton"
        >
          😊
        </button>
        <button onClick={sendClicked} className="send-button">
          ارسال
        </button>

        {showStickers && (
          <div className="sticker-panel show">
            {stickers.map((sticker, index) => (
              <button
                key={sticker}
                onClick={() => handleStickerClick(sticker)}
                className="stickerbutton hover:scale-110 transition"
              >
                {sticker}
              </button>
            ))}
          </div>
        )}
      </span>
    </div>
  );
}

export default SupportPanel;
